<template>
  <v-container>
    <div v-if="posts.length == 0">
      <v-skeleton-loader
        v-for="n in 10"
        :key="n"
        class="mx-auto"
        max-width="800"
        type="list-item-avatar-three-line"
        loading
      ></v-skeleton-loader>
    </div>

    <h1 class="display-2 font-weight-thin text-center mt-mb">HortusBlog</h1>

    <v-row class="mt-mb">
      <v-col v-for="(category, i) in categorys" :key="i" md="4">
        <v-hover 
          v-slot="{ hover }"
          open-delay="100"
        >
          <v-card
            class="card mx-auto my-2"
            width="400"
            :elevation="hover ? 12 : 5"
            @click="goCat(category)"
          >
            <v-img class="imgCat" :src="`/gimc/strapi/${category.hotTopic.imageHeader.url}?height=300`" />
            <div class="bloc">
              <div class="titre text-center">{{category.name}}</div>
            </div>
            <v-list-item three-line>
              <v-list-item-content class="catInfo">
                <v-list-item-subtitle style="font-size: 1.1rem; color: black;" class="text-center catTitre">{{category.hotTopic.title}}</v-list-item-subtitle>
                <v-list-item-subtitle class="text-center subtitle-2">{{category.hotTopic.brief}}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-card flat class="mt-mb">
      <v-tabs
      color="#0b755f"
      centered
        v-model="tab"
        light
      >
        <v-tab>Tous</v-tab>
        <v-tabs-slider color="#0b755f"></v-tabs-slider>
        <v-tab
          v-for="(category, i) in categorys"
          :key="i"
        >
          {{ category.name }}
        </v-tab>
        <v-tabs-slider color="#0b755f"></v-tabs-slider>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card flat>
            <v-card-text>          
              <v-row v-for="post in posts" :key="post.slug" :elevation="5">
                <v-hover
                    v-slot:default="{ hover }"
                    close-delay="100"
                  >
                  <v-card
                    class="mx-auto my-2"
                    width="800"
                    style="cursor: pointer"
                    outlined
                    :elevation="hover ? 12 : 2"
                    @click="goPost(post)"
                  >
                    <v-list-item three-line>
                      <v-list-item-content>
                        <div class="overline mb-4">{{post.publishedDate.split('T')[0]}}</div>
                        <v-list-item-title class="headline">{{ post.title }}</v-list-item-title>
                        <v-list-item-subtitle v-html="post.brief"></v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                      >
                      
                        <v-img :src="`/gimc/strapi/${post.imageHeader.url}?height=60`"></v-img>
                      </v-list-item-avatar>
                    </v-list-item>
                  </v-card>
                </v-hover>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item> 
        <v-tab-item
          v-for="category in categorys"
          :key="category.tab"
        >
          <v-card flat>
            <v-card-text>
              <v-row v-for="cat in category.posts" :key="cat.test">
                <v-hover
                    v-slot:default="{ hover }"
                    close-delay="100"
                  >
                  <v-card
                    class="mx-auto my-2"
                    width="800"
                    style="cursor: pointer"
                    outlined
                    :elevation="hover ? 12 : 2"
                    @click="go(cat)"
                  >
                    <v-list-item three-line>
                      <v-list-item-content>
                        <div class="overline mb-4">{{cat.publishedDate.split('T')[0]}}</div>
                        <v-list-item-title class="headline">{{ cat.title }}</v-list-item-title>
                        <v-list-item-subtitle v-html="cat.brief"></v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-avatar
                        tile
                        size="80"
                        color="grey"
                      >
                        <v-img :src="`/gimc/strapi/${cat.imageHeader.url}?height=60`"></v-img>
                        </v-list-item-avatar>
                    </v-list-item>
                  </v-card>
                </v-hover>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  data: () => ({
    tab: null,
  }),
  computed: {
    ...mapGetters('strapiBlog', ['posts', 'categorys']),
  },
  methods: {
    ...mapActions('strapiBlog', ['getCategory', 'getPosts']),
    go (cat) {
      this.$router.push(`/blog/post/${cat.slug}`)
    },
    goPost (post) {
      this.$router.push(`/blog/post/${post.slug}`)
    },
    goCat (category) {
      this.$router.push(`/blog/post/${category.hotTopic.slug}`)
    }
  },
  async mounted () {
    this.getCategory();
    this.getPosts()
  }  
}
</script>
<style scoped>
.catTitre {
  margin-bottom: 5%;
}
h1, .color {
  color: #0b755f;
}
.card {
  height: 400px;
}
.imgCat {
  max-height: 200px;
}
.bloc {
  display : table;
  margin : 0 auto;
}
.titre {
  position: relative;
  font-size: 1.2rem;
  background: #0b755f;
  padding: 0.4rem 0.7rem;
  border-radius: 10px;
  color: white;
  margin-top: -20px;
  margin-bottom: 8%;
}
.catInfo {
  margin-top: 15px;
}
.mt-mb {
  margin: 3rem;
}
@media screen and (max-width: 1050px) {
  .titre {
    margin-top: -17px;
    font-size: .8rem;
  }
  .card {
    height: 350px;
  }
  .catTitre {
    margin-bottom: 8%;
  }
} 
</style>
